// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalWrapper_wrapper__2805S"};